/* Garage 505 — interacciones del tema:
   «Tu vehículo» (buscador Marca → Modelo → Motor), filtro de grillas, verificación de compatibilidad,
   búsqueda instantánea por nombre o código OEM, carrito lateral (AJAX) y enlaces de WhatsApp. */
(() => {
  'use strict';

  const cfg = (window.G505 && window.G505.config) || {};
  const routes = cfg.routes || {};
  const brand = cfg.brand || 'Garage 505';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const clp = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-CL');
  const store = {
    get(k, d) { try { const v = localStorage.getItem('g505:' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem('g505:' + k, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } }
  };
  const ICON = {
    check: '<path d="m5 12.5 4.2 4.2L19 7"/>',
    alert: '<path d="M12 3.5 2.5 20h19Z"/><path d="M12 10v4.5M12 17.2v.1"/>',
    x: '<path d="M6 6l12 12M18 6 6 18"/>',
    shield: '<path d="M12 3 5 6v5.5c0 4.4 3 8.2 7 9.5 4-1.3 7-5.1 7-9.5V6Z"/><path d="m8.8 12 2.3 2.3 4.3-4.6"/>'
  };
  const icon = (n) => '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICON[n] || '') + '</svg>';
  const waHref = (msg) => 'https://wa.me/' + (cfg.whatsapp || '') + '?text=' + encodeURIComponent(msg);

  /* ------------------------------------------------------------------
     «Tu vehículo»
     ------------------------------------------------------------------ */
  let VEH = [];
  try { VEH = JSON.parse((($('#g505-vehicles') || {}).textContent) || '[]'); } catch (e) { VEH = []; }
  let saved = store.get('vehiculo', null); // { slug, motor }

  const current = () => {
    if (!saved) return null;
    const v = VEH.find((x) => x.slug === saved.slug);
    if (!v) return null;
    const m = (v.motores || []).find((x) => x.tag === saved.motor) || null;
    return { v, m };
  };
  const vehicleName = () => {
    const a = current();
    if (!a) return '';
    return a.v.marca + ' ' + a.v.modelo + (a.m && a.v.motores.length > 1 ? ' · ' + a.m.nombre : '');
  };
  const fits = (tags) => {
    const a = current();
    if (!a || !a.v.tag) return null;
    return a.m ? tags.includes(a.m.tag) : tags.includes(a.v.tag);
  };
  const setVehicle = (slug, motor) => {
    saved = slug ? { slug, motor: motor || '' } : null;
    store.set('vehiculo', saved);
    paint();
  };

  /* ------------------------------------------------------------------
     Grillas: pestañas por categoría + filtro por vehículo
     ------------------------------------------------------------------ */
  const tabState = {};
  const applyGrid = (grid) => {
    const key = grid.dataset.grid;
    const tab = tabState[key] || 'all';
    const a = current();
    const cards = $$('[data-card]', grid);
    let visible = 0;
    cards.forEach((card) => {
      const tags = (card.dataset.tags || '').split('|');
      const fit = fits(tags);
      const show = (tab === 'all' || card.dataset.type === tab) && fit !== false;
      card.hidden = !show;
      if (show) visible += 1;
      const badge = $('[data-fit]', card);
      if (badge) {
        badge.hidden = fit !== true;
        if (fit === true) $('span', badge).textContent = 'Sirve para tu ' + (a.v.corto || a.v.modelo);
      }
    });
    const empty = $('[data-grid-empty]', grid);
    if (empty) empty.hidden = !(cards.length && visible === 0);
  };

  const paintNotes = () => {
    const name = vehicleName();
    $$('[data-filter-note]').forEach((el) => {
      if (!el.dataset.default) el.dataset.default = el.innerHTML;
      el.innerHTML = name
        ? 'Mostrando repuestos para <b>' + esc(name) + '</b> · <button class="link-btn" type="button" data-clear-vehicle>Ver todos</button>'
        : el.dataset.default;
    });
    $$('[data-vehicle-name]').forEach((el) => { el.textContent = name || 'tu vehículo'; });
    const chip = $('#my-vehicle');
    if (chip) {
      chip.classList.toggle('show', !!name);
      const b = $('b', chip);
      if (b) b.textContent = name;
    }
  };

  /* ------------------------------------------------------------------
     Ficha: ¿sirve para tu vehículo?
     ------------------------------------------------------------------ */
  const vehicleOptions = () => VEH.filter((v) => !v.cotizar).map((v) =>
    v.motores.map((m) => '<option value="' + esc(v.slug + '|' + m.tag) + '">' + esc(v.marca + ' ' + v.modelo + ' · ' + m.nombre) + '</option>').join('')
  ).join('');

  const renderFitcheck = (el) => {
    const tags = (el.dataset.tags || '').split('|');
    const confirm = el.dataset.confirm === 'true';
    const a = current();
    const fit = fits(tags);
    const name = vehicleName();
    const change = ' <button class="link-btn" type="button" data-clear-vehicle>Cambiar vehículo</button>';
    el.classList.remove('yes', 'no', 'ask');
    if (fit === true && !confirm) {
      el.classList.add('yes');
      el.innerHTML = icon('check') + '<div><b>Sirve para tu ' + esc(name) + '</b><span>Según el código de fábrica y nuestra experiencia con este vehículo.' + change + '</span></div>';
    } else if (fit === true) {
      el.classList.add('ask');
      el.innerHTML = icon('alert') + '<div><b>Debería servir para tu ' + esc(name) + '. Confirmémoslo.</b><span>Este repuesto puede variar según el furgón. Envíanos tu patente y lo verificamos antes de que pagues.' + change + '</span></div>';
    } else if (fit === false) {
      const url = (a.m && a.m.url) || a.v.url;
      el.classList.add('no');
      el.innerHTML = icon('x') + '<div><b>No sirve para tu ' + esc(name) + '</b><span>Es para: ' + esc(el.dataset.compat || '') + '. <a class="link-btn" href="' + esc(url) + '">Ver repuestos para tu vehículo</a>' + change + '</span></div>';
    } else {
      el.classList.add('ask');
      el.innerHTML = icon('shield') + '<div style="flex:1"><b>¿Sirve para tu vehículo?</b><span>Elige tu vehículo y te lo decimos al tiro.</span>' +
        '<div class="field" style="margin-top:10px"><select data-fit-select aria-label="Elige tu vehículo"><option value="">Elige tu vehículo y motor</option>' + vehicleOptions() + '</select></div></div>';
      const sel = $('[data-fit-select]', el);
      sel.addEventListener('change', () => {
        if (!sel.value) return;
        const [slug, motor] = sel.value.split('|');
        setVehicle(slug, motor);
      });
    }
  };

  /* ------------------------------------------------------------------
     WhatsApp: mensajes con el vehículo elegido
     ------------------------------------------------------------------ */
  const refreshWa = () => {
    const name = vehicleName();
    $$('[data-wa]').forEach((a) => {
      let msg = (a.dataset.wa || '').trim();
      if (a.hasAttribute('data-wa-vehicle') && name) msg += (/[.:?!]$/.test(msg) ? ' ' : '. ') + 'Mi vehículo: ' + name + '.';
      if (a.hasAttribute('data-wa-ask-plate')) msg += ' Mi patente o VIN es: ';
      a.href = waHref(msg);
    });
  };

  const paint = () => {
    paintNotes();
    $$('[data-grid]').forEach(applyGrid);
    $$('[data-fitcheck]').forEach(renderFitcheck);
    refreshWa();
  };

  /* ------------------------------------------------------------------
     Buscador por vehículo (portada)
     ------------------------------------------------------------------ */
  const initFinder = (form) => {
    const fm = $('[data-f-marca]', form);
    const fmo = $('[data-f-modelo]', form);
    const fmt = $('[data-f-motor]', form);
    const go = $('[data-f-go]', form);
    if (!fm || !fmo || !fmt || !go) return;
    const marcas = [...new Set(VEH.map((v) => v.marca))];
    fm.insertAdjacentHTML('beforeend', marcas.map((m) => '<option>' + esc(m) + '</option>').join(''));

    const motores = () => {
      const v = VEH.find((x) => x.slug === fmo.value);
      fmt.innerHTML = '<option value="">Todos los motores</option>' +
        (v ? v.motores.map((m) => '<option value="' + esc(m.tag) + '">' + esc(m.nombre) + '</option>').join('') : '');
      fmt.disabled = !v || v.motores.length < 2;
      if (v && v.motores.length === 1) fmt.value = v.motores[0].tag;
      go.disabled = !v;
      go.textContent = v && v.cotizar ? 'Cotizar por WhatsApp' : 'Ver repuestos compatibles';
    };
    const modelos = () => {
      const list = VEH.filter((v) => v.marca === fm.value);
      fmo.innerHTML = '<option value="">Elige el modelo</option>' + list.map((v) => '<option value="' + esc(v.slug) + '">' + esc(v.modelo) + '</option>').join('');
      fmo.disabled = !fm.value;
      if (list.length === 1) fmo.value = list[0].slug;
      motores();
    };
    fm.addEventListener('change', modelos);
    fmo.addEventListener('change', motores);
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = VEH.find((x) => x.slug === fmo.value);
      if (!v) return;
      if (v.cotizar) {
        window.open(waHref('Hola ' + brand + ', necesito repuestos para mi ' + v.marca + '. Modelo y año: '), '_blank', 'noopener');
        return;
      }
      const m = v.motores.find((x) => x.tag === fmt.value);
      setVehicle(v.slug, m ? m.tag : '');
      window.location.href = (m && m.url) || v.url;
    });

    const a = current();
    if (a) {
      fm.value = a.v.marca; modelos();
      fmo.value = a.v.slug; motores();
      if (a.m) fmt.value = a.m.tag;
    }
  };

  /* ------------------------------------------------------------------
     Búsqueda instantánea (nombre, vehículo o código OEM)
     ------------------------------------------------------------------ */
  const initSearch = (form) => {
    const input = $('input[name="q"]', form);
    const box = $('.search-results', form);
    if (!input || !box || !routes.predictive) return;
    if (window.matchMedia('(max-width: 600px)').matches && input.dataset.placeholderMobile) input.placeholder = input.dataset.placeholderMobile;
    let timer = null;
    let ctrl = null;
    let sel = -1;

    const fetchResults = async (q) => {
      const url = routes.predictive + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][fields]=title,product_type,variants.sku,tag,vendor&section_id=predictive-search';
      const res = await fetch(url, { signal: ctrl.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const wrap = doc.querySelector('[data-count]');
      return wrap ? { count: Number(wrap.dataset.count), html: wrap.innerHTML } : { count: 0, html: '' };
    };

    const run = async () => {
      const q = input.value.trim();
      sel = -1;
      if (q.length < 2) { box.classList.remove('open'); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        let r = await fetchResults(q);
        const compact = q.replace(/[^0-9a-z]/gi, '');
        if (!r.count && compact !== q && compact.length >= 4) r = await fetchResults(compact);
        box.innerHTML = r.count
          ? r.html + '<a class="sr-all" href="' + esc(routes.search + '?type=product&q=' + encodeURIComponent(q)) + '">Ver todos los resultados</a>'
          : '<div class="sr-empty">No encontramos “' + esc(q) + '” en la tienda. <a class="link-btn" href="' + esc(waHref('Hola ' + brand + ', busco este repuesto: ' + q + '.')) + '" target="_blank" rel="noopener">Pregúntanos por WhatsApp</a>: lo conseguimos.</div>';
        box.classList.add('open');
      } catch (e) {
        if (e.name !== 'AbortError') box.classList.remove('open');
      }
    };

    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
    input.addEventListener('focus', () => { if (input.value.trim().length >= 2) run(); });
    input.addEventListener('keydown', (e) => {
      const items = $$('.sr-item', box);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach((it, i) => it.classList.toggle('active', i === sel));
      } else if (e.key === 'Enter' && sel >= 0 && items[sel]) {
        e.preventDefault();
        window.location.href = items[sel].getAttribute('href');
      } else if (e.key === 'Escape') {
        box.classList.remove('open');
      }
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('[data-search]')) box.classList.remove('open'); });
  };

  /* ------------------------------------------------------------------
     Carrito (AJAX API de Shopify)
     ------------------------------------------------------------------ */
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };
  const Cart = {
    async get() {
      const r = await fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } });
      return r.json();
    },
    async add(items) {
      const r = await fetch(routes.cartAdd + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items }) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || 'No pudimos agregar el producto.');
      return d;
    },
    async addForm(form) {
      const r = await fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const d = await r.json();
      if (!r.ok) throw new Error(d.description || d.message || 'No pudimos agregar el producto.');
      return d;
    },
    async change(key, quantity) {
      const r = await fetch(routes.cartChange + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ id: key, quantity }) });
      return r.json();
    }
  };

  const sized = (url, w) => (url ? url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : '');

  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((b) => { b.textContent = cart.item_count || ''; b.dataset.n = cart.item_count; });
    const list = $('#cart-items');
    if (!list) return;
    if (!cart.item_count) {
      list.innerHTML = '<div class="cart-empty"><p>Tu carrito está vacío.</p><p>Elige tu vehículo y te mostramos solo lo que le sirve.</p></div>';
    } else {
      list.innerHTML = cart.items.map((it) => {
        const name = String(it.product_title || it.title).split(' · ')[0];
        const code = it.sku && it.sku.indexOf('G505-') !== 0 ? '<small class="mono">OEM ' + esc(it.sku) + '</small>' : '';
        const props = Object.entries(it.properties || {})
          .filter(([k, v]) => v && k.charAt(0) !== '_')
          .map(([k, v]) => '<small class="prop">' + esc(k) + ': ' + esc(v) + '</small>').join('');
        const img = it.image ? '<img src="' + esc(sized(it.image, 160)) + '" alt="" width="64" height="64" loading="lazy">' : '';
        return '<div class="ci">' +
          '<a class="t" href="' + esc(it.url) + '">' + img + '</a>' +
          '<div><h4><a href="' + esc(it.url) + '">' + esc(name) + '</a></h4>' + code + props +
            '<div class="qty">' +
              '<button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Agregar uno">+</button>' +
            '</div></div>' +
          '<div class="p">' + clp(it.final_line_price) + '<button class="rm" type="button" data-line="' + esc(it.key) + '" data-q="0">Quitar</button></div>' +
        '</div>';
      }).join('');
    }
    const total = $('#cart-total');
    if (total) total.textContent = clp(cart.total_price);
    const checkout = $('[data-checkout]');
    if (checkout) checkout.classList.toggle('is-disabled', !cart.item_count);
    const wa = $('#wa-order');
    if (wa) {
      const lines = cart.items.map((it) => '• ' + it.quantity + ' x ' + it.product_title + (it.sku && it.sku.indexOf('G505-') !== 0 ? ' [' + it.sku + ']' : '')).join('\n');
      const veh = vehicleName();
      wa.href = waHref('Hola ' + brand + ', quiero comprar:\n' + lines + '\nTotal: ' + clp(cart.total_price) + (veh ? '\nVehículo: ' + veh : ''));
      wa.hidden = !cart.item_count;
    }
  };

  const drawer = () => $('#drawer');
  let lastFocus = null;
  const openCart = () => {
    const d = drawer();
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    const scrim = $('#scrim');
    if (scrim) scrim.classList.add('open');
    d.focus();
    return true;
  };
  const closeCart = () => {
    const d = drawer();
    if (!d) return;
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    const scrim = $('#scrim');
    if (scrim) scrim.classList.remove('open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  let toastTimer = null;
  const toast = (msg, isError) => {
    const t = $('#toast');
    if (!t) return;
    $('span', t).textContent = msg;
    t.classList.toggle('error', !!isError);
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('show'), 2600);
  };

  const refreshCart = async (open) => {
    try {
      const cart = await Cart.get();
      renderCart(cart);
      if (open) openCart();
    } catch (e) { /* si falla, la página /cart sigue funcionando */ }
  };

  const withLoading = async (btn, fn) => {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try { await fn(); } finally { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } }
  };

  /* ------------------------------------------------------------------
     Eventos
     ------------------------------------------------------------------ */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-add-variant],[data-add-kit],[data-line],[data-open-cart],[data-close-cart],[data-clear-vehicle],[data-copy],[data-thumb],[data-qty-inc],[data-qty-dec],[data-tab],[data-vehicle-pick],[data-checkout]');
    if (!t) return;

    if (t.hasAttribute('data-add-variant')) {
      withLoading(t, async () => {
        try {
          await Cart.add([{ id: Number(t.dataset.addVariant), quantity: 1 }]);
          await refreshCart(true);
          toast('Agregado al carrito');
        } catch (err) { toast(err.message, true); }
      });
    } else if (t.hasAttribute('data-add-kit')) {
      const items = t.dataset.addKit.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
      withLoading(t, async () => {
        try {
          await Cart.add(items);
          await refreshCart(true);
          toast('Kit agregado al carrito');
        } catch (err) { toast(err.message, true); }
      });
    } else if (t.hasAttribute('data-line')) {
      withLoading(t, async () => { renderCart(await Cart.change(t.dataset.line, Number(t.dataset.q))); });
    } else if (t.hasAttribute('data-open-cart')) {
      if (openCart()) { e.preventDefault(); refreshCart(false); }
    } else if (t.hasAttribute('data-close-cart')) {
      closeCart();
    } else if (t.hasAttribute('data-checkout')) {
      if (t.classList.contains('is-disabled')) e.preventDefault();
    } else if (t.hasAttribute('data-clear-vehicle')) {
      setVehicle(null);
    } else if (t.hasAttribute('data-copy')) {
      const text = t.dataset.copy;
      const done = () => { t.textContent = 'Copiado'; setTimeout(() => { t.textContent = 'Copiar'; }, 1500); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, () => {});
    } else if (t.hasAttribute('data-thumb')) {
      const main = $('[data-main-media] img');
      if (main) {
        main.src = t.dataset.src;
        main.srcset = t.dataset.srcset;
        main.alt = '';
      }
      $$('[data-thumb]').forEach((b) => b.setAttribute('aria-current', b === t ? 'true' : 'false'));
    } else if (t.hasAttribute('data-qty-inc') || t.hasAttribute('data-qty-dec')) {
      const input = $('input', t.closest('[data-qty]'));
      if (input) input.value = Math.max(1, Number(input.value || 1) + (t.hasAttribute('data-qty-inc') ? 1 : -1));
    } else if (t.hasAttribute('data-tab')) {
      const group = t.closest('[data-tabs]');
      if (!group) return;
      const key = group.dataset.tabs;
      tabState[key] = t.dataset.tab;
      $$('[data-tab]', group).forEach((b) => b.setAttribute('aria-pressed', b === t ? 'true' : 'false'));
      const grid = $('[data-grid="' + key + '"]');
      if (grid) applyGrid(grid);
    } else if (t.hasAttribute('data-vehicle-pick')) {
      const v = VEH.find((x) => x.slug === t.dataset.vehiclePick);
      if (v) setVehicle(v.slug, v.motores.length === 1 ? v.motores[0].tag : '');
    }
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !drawer()) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    withLoading(btn, async () => {
      try {
        await Cart.addForm(form);
        await refreshCart(true);
        toast('Agregado al carrito');
      } catch (err) { toast(err.message, true); }
    });
  });

  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  /* ------------------------------------------------------------------
     Inicio
     ------------------------------------------------------------------ */
  $$('[data-finder]').forEach(initFinder);
  $$('[data-search]').forEach(initSearch);
  paint();
  if ($('#cart-items')) refreshCart(false);
})();
